import type { CoreApiClient } from "../client";
import { createFloorMutations } from "../mutations/floor.mutations";
import { createFloorQueries } from "../queries/floor.queries";

export const createFloorRepository = (api: CoreApiClient) => ({
  ...createFloorQueries(api),
  ...createFloorMutations(api),
});
